import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  loadingSpinner: {
    marginTop: pxToRem(60),
  },
  iframe_embed: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    height: '100%',
    width: '100%',
    border: 0,
  },
});
